// Friendly text for the server's order-action error codes. Anything that isn't a
// known code (already-readable sentences, unknown values) passes through unchanged.
const ORDER_ACTION_ERROR_MESSAGES: Record<string, string> = {
  PICKUP_DATE_REQUIRED: 'Set a pickup date before marking the load ready for pickup.',
  PO_NUMBER_REQUIRED: 'This sub-location requires a PO number.',
};

export function describeOrderActionError(error: unknown, fallback: string): string {
  if (typeof error !== 'string' || !error) return fallback;
  return ORDER_ACTION_ERROR_MESSAGES[error] ?? error;
}
